module.exports = __webpack_public_path__ + "media/1fie-j-bene'se'kwell.e0eb249d.mp3";